import { History } from 'history';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { HotelDetail } from '../hotels/HotelDetail';
import { CMS, HotelBedData, SecurityData } from '../shared/index';
import { getAjaxhelper } from '../utils/CoreAjaxHelper';
import { isNull, getStaticPage } from '../utils/index';
import { IndexDestination } from './destination/IndexDestination';
import { IndexBlog } from './IndexBlog';
import { PageMaster } from '../static-content/PageMaster';
import { IndexPromotions } from './IndexPromotions';
import { IndexSegment } from './IndexSegment';
import { IndexWedding } from './IndexWedding';
export interface SlugData {
    id?: string | number;
    lang?: string;

}

export interface MetaSlugData {
    title?: string;
    description?: string;
    keyword?: string;
}

export interface IndexCMSProps extends BaseComponentProps {
    lang: string;
    slug: string;
    currency: string;
    userLogin: SecurityData.ApplicationUser;
    /** 
     * size page per request
     */
    pageSize: number;

    /**
     * page yang active
     */
    initialPage?: number;

    history?: History;

    wishlistCount: (c: number) => any;

    getHotels: (lang: string, page: number, count: number, filter: HotelBedData.SearchFilter, externalFilter: HotelBedData.ExternalFilter) => any;

    responKey: string;
    initialFilter: HotelBedData.SearchFilter;

    updateInternalFilter: (filter: HotelBedData.SearchFilter) => any;

    /**
     * real time database ref
     */
    realtimeDb: firebase.database.Database;

    firestoreDb: firebase.firestore.Firestore;
    /**
     * firebase uuid
     */
    uuid: string;

    newRequestAvailability: (dari: string) => any;
    firebaseApp: firebase.app.App;

    reqAvailableDetailId?: number;

    night?: string;

    pageChange: (page: number, dari: string) => any;
    page: number;
}

export interface IndexCMSState extends BaseComponentState {
    model: string;
    data: SlugData | any;
    haveHotel: boolean;
    modelId: string | number;
    blogContentData?: any;
    panelState: 'REQUESTING' | 'COMPALTE' | 'ERROR';
    panelListHotel: 'REQUESTING' | 'COMPALTE' | 'ERROR';
    errorMessage?: string;
    meta?: MetaSlugData;
    masterPage?: string;
}

export class IndexCMS extends BaseComponent<IndexCMSProps, IndexCMSState> {
    constructor(props: IndexCMSProps) {
        super(props);
        this.state = {
            model: '404',
            data: {},
            haveHotel: true,
            modelId: 0,
            panelState: 'REQUESTING',
            panelListHotel: 'REQUESTING',
            meta: {
                title: '', description: '', keyword: ''
            }
        };
    }

    getSlug = () => {
        if (!isNull(this.props.slug)) {
            getAjaxhelper().post(`/dynamics/rest-api/generic/CmsSlug`, {
                eraseAuditTrail: true,
                q: {
                    slug: { $eq: this.props.slug }
                },
            }).then(
                (d) => { 
                    if (d.count > 0) {
                        this.setStateHelper(
                            st => {
                                for (let a of d.rows) {
                                    // let x: SlugData = JSON.parse(a.data);
                                    st.data = JSON.parse(a.data);
                                    st.model = a.model;
                                    if (a.model === 'Hotel') {
                                        st.haveHotel = false;
                                    }
                                    st.modelId = JSON.parse(a.data).id;
                                    let m: CMS.CmsSlug = a;
                                    st.meta = {
                                        description: m.description,
                                        title: m.title,
                                        keyword: m.keyword
                                    };
                                }
                            },
                            () => {
                                this.getSlugData();
                                getStaticPage(this.props.lang, this.props.history!.location.pathname).then(
                                    e => {
                                        // console.log("Static Content", e);
                                        this.setState({ masterPage: e });
                                    }
                                ).catch(
                                    err => {
                                        console.log("Static Content Error", err);
                                        this.setState({ masterPage: "<span/>" });
                                    }
                                );
                            });
                    } else {
                        this.setStateHelper(st => {
                            st.model = '404';
                        });
                    }
                }).catch((exc) => { console.error('error: ', exc); });
        }
    }

    componentDidMount() {
        if (this.props.slug !== 'privacy-policy' && this.props.slug !== 'terms-of-use' && this.props.slug !== 'faqs') {
            this.getSlug();
        }

    }

    componentDidUpdate(prevProps: IndexCMSProps, prevState: IndexCMSState) {
        if (prevProps !== this.props) { this.getSlug(); }
    }

    getSlugData: () => any = () => {
        if (this.state.model === 'Wedding') {
            getAjaxhelper().post(`/dynamics/hb-api/cms-wedding`, {code: this.state.modelId }).then(
                (d: any) => {
                    this.setStateHelper(st => {
                        st.blogContentData = d;
                        st.panelState = 'COMPALTE';
                    });
                }).catch((exc) => {
                    console.error('error: ', exc);
                    this.setState({ errorMessage: exc.message, panelState: 'ERROR' });
                });
        } else if (this.state.model !== 'Master') {
            getAjaxhelper().get(`/dynamics/rest-api/generic/${this.state.model}/${this.state.modelId}`).then(
                (d: any) => {
                    this.setStateHelper(st => {
                        st.blogContentData = d;
                        st.panelState = 'COMPALTE';
                    });
                }).catch((exc) => {
                    console.error('error: ', exc);
                    this.setState({ errorMessage: exc.message, panelState: 'ERROR' });
                });
        }  else if (this.state.model === 'Master') {
            this.setStateHelper(st => {
                // st.blogContentData = d;
                st.panelState = 'COMPALTE';
            });
        }
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        let page = <span />;
        // let hotelList = <span />;
        if (this.state.panelState === 'COMPALTE') {
            switch (this.state.model) {
                case 'Master':
                    // console.log("Master Content", this.state);
                    page = (<PageMaster lang={this.props.lang} content={this.state.masterPage} />);
                    break;
                case 'CmsDestinationsZones':
                    // console.log("IndexCMSState", this.state);
                    page = (<IndexDestination page={this.props.page} pageChange={this.props.pageChange} firebaseApp={this.props.firebaseApp} updateInternalFilter={this.props.updateInternalFilter} uuid={this.props.uuid} firestoreDb={this.props.firestoreDb} getHotels={this.props.getHotels} realtimeDb={this.props.realtimeDb} newRequestAvailability={this.props.newRequestAvailability} initialFilter={this.props.initialFilter} wishlistCount={this.props.wishlistCount} history={this.props.history as any} data={this.state.blogContentData} lang={this.props.lang} currency={this.props.currency} pageSize={this.props.pageSize} />);
                    break;
                case 'Hotel':
                    // console.log("IndexCMSState", this.state);
                    page = (<HotelDetail firebaseApp={this.props.firebaseApp} night={this.props.night} reqAvailableDetailId={this.props.reqAvailableDetailId} updateInternalFilter={this.props.updateInternalFilter} responKey={this.props.responKey} userLogin={this.props.userLogin} history={this.props.history} currency={this.props.currency} getHotels={this.props.getHotels} slug={this.props.slug} id={this.state.data.id} lang={this.props.lang} />);
                    break;
                case 'CmsHotelSegment':
                    // console.log("IndexCMSState", this.state);
                    page = (<IndexSegment page={this.props.page} pageChange={this.props.pageChange} firebaseApp={this.props.firebaseApp} updateInternalFilter={this.props.updateInternalFilter} uuid={this.props.uuid} firestoreDb={this.props.firestoreDb} realtimeDb={this.props.realtimeDb} newRequestAvailability={this.props.newRequestAvailability} initialFilter={this.props.initialFilter} getHotels={this.props.getHotels} wishlistCount={this.props.wishlistCount} history={this.props.history as any} data={this.state.blogContentData} lang={this.props.lang} currency={this.props.currency} pageSize={this.props.pageSize} />);
                    break;

                case 'CmsPromotion':
                    // console.log("IndexCMSState", this.state);
                    page = (<IndexPromotions page={this.props.page} pageChange={this.props.pageChange} firebaseApp={this.props.firebaseApp} updateInternalFilter={this.props.updateInternalFilter} uuid={this.props.uuid} firestoreDb={this.props.firestoreDb} getHotels={this.props.getHotels} realtimeDb={this.props.realtimeDb} newRequestAvailability={this.props.newRequestAvailability} initialFilter={this.props.initialFilter} wishlistCount={this.props.wishlistCount} history={this.props.history as any} data={this.state.blogContentData} lang={this.props.lang} currency={this.props.currency} pageSize={this.props.pageSize} />);
                    break;
                case 'CmsBlog':
                    // console.log("CmsBlog", this.state);
                    page = (<IndexBlog initialFilter={this.props.initialFilter} userLogin={this.props.userLogin} slug={this.props.slug} getHotels={this.props.getHotels} wishlistCount={this.props.wishlistCount} history={this.props.history as any} data={this.state.blogContentData} lang={this.props.lang} currency={this.props.currency} pageSize={this.props.pageSize} />);
                    break;
                case 'Wedding':
                    // console.log("CmsBlog", this.state);
                    page = (<IndexWedding initialFilter={this.props.initialFilter} userLogin={this.props.userLogin} slug={this.props.slug} getHotels={this.props.getHotels} wishlistCount={this.props.wishlistCount} history={this.props.history as any} data={this.state.blogContentData} lang={this.props.lang} currency={this.props.currency} pageSize={this.props.pageSize} />);
                    break;
                default:
                    page = <span />;
                    break;
            }
        }

        return (
            <div>
                <Helmet>
                    <title>{this.state.meta!.title}</title>
                    <meta name="description" content={this.state.meta!.description} />
                    <meta name="keywords" content={this.state.meta!.keyword} />
                </Helmet>
                {page}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/cms/IndexCMS.tsx